// extracted by mini-css-extract-plugin
export default {"install":"bd0e6c68b7b0","bubbles":"e51565e7e34d"};